module.exports = class ClientsListCtrl
  constructor: ->
    @updateTable = @updateTable.bind(@)

  updateTable: ->
    @onRefresh()
